import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { useCallback, useEffect, useState } from "react";
import DadosGeograficosService from "../../../../../../main/services/DadosGeograficosService";
import ServicoAcolhimentoService from "../../../../../../main/services/ServicoAcolhimentoService";

export const LocalizacaoServicoAba = ({ children, props }) => {
  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });
  const [bairros, setBairros] = useState({ options: [], isLoading: false });
  const [estados, setEstados] = useState({ options: [], isLoading: false });

  const [nomesServicosAcolhimento, setNomesServicosAcolhimento] = useState({
    options: [],
    isLoading: false,
  });

  useEffect(() => {
    setMunicipios((prevState) => ({ ...prevState, isLoading: true }));
    const idsEstados = props?.values?.idEstado[0]?.map((estado) => estado.id);

    if (idsEstados?.length > 0) {
      DadosGeograficosService.pesquisarMunicipiosArray(idsEstados)
        .then((res) => {
          const allOption = { id: "", descricao: "Todos" };

          const mappedOptions = res.data.map((item) => ({
            id: item.id,
            descricao: item.nome,
            idEstado: item.uf.id,
          }));
          setMunicipios({
            options:
              mappedOptions.length > 0 ? [allOption, ...mappedOptions] : [],
            isLoading: false,
          });
        })
        .catch(() => {
          setMunicipios({
            options: [],
            isLoading: false,
          });
        });
    } else {
      setMunicipios({ options: [], isLoading: false });
    }
  }, [props?.values?.idEstado, setMunicipios]);

  useEffect(() => {
    setBairros((prevState) => ({ ...prevState, isLoading: true }));
    const idsMunicipios = props?.values?.idMunicipio[0]?.map(
      (municipio) => municipio.id,
    );

    const idsEstados = props?.values?.idEstado[0]?.map((estado) => estado.id);
    if (idsMunicipios?.length > 0 && idsEstados?.length > 0) {
      DadosGeograficosService.pesquisarBairrosArray(idsMunicipios)
        .then((res) => {
          const allOption = { id: "", descricao: "Todos" };

          const mappedOptions = res.data.map((item) => ({
            id: item.id,
            descricao: item.nome,
            idMunicipio: item.cidade.id,
          }));
          setBairros({
            options:
              mappedOptions.length > 0 ? [allOption, ...mappedOptions] : [],
            isLoading: false,
          });
        })
        .catch(() => {
          setBairros({
            options: [],
            isLoading: false,
          });
        });
    } else {
      setBairros({ options: [], isLoading: false });
    }
  }, [props?.values?.idMunicipio, props?.values?.idEstado, setBairros]);

  const handleGetEstados = useCallback(() => {
    setEstados((prev) => ({ ...prev, isLoading: true }));

    DadosGeograficosService.getEstados().then((res) => {
      setEstados({ options: res.data, isLoading: false });
    });
  }, [setEstados]);

  const handleGetServicosAcolhimento = (props) => {
    setNomesServicosAcolhimento({
      ...nomesServicosAcolhimento,
      isLoading: true,
    });

    const idsMunicipios = props?.values?.idMunicipio[0]?.map(
      (municipio) => municipio.id,
    );

    const idsEstados = props?.values?.idEstado[0]?.map((estado) => estado.id);

    const idsBairros = props?.values?.idBairro[0]?.map((bairro) => bairro.id);

    ServicoAcolhimentoService.pesquisarServicosAcolhimento({
      municipios: idsMunicipios,
      estados: idsEstados,
      bairros: idsBairros,
    }).then((res) => {
      setNomesServicosAcolhimento({ options: res.data, isLoading: false });
    });
  };

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Localização do Serviço de Acolhimento
        </Text>
        {children}
      </Flex>

      <Grid templateColumns="repeat(9, 1fr)" gap="15px" mt="15px" w="100%">
        <GridItem colSpan={{ base: 9, lg: 4, xl: 3 }}>
          <CustomMultiSelectWField
            fieldName="idEstado"
            label="Estado"
            placeholder="Selecione o Estado"
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.id}
            values={props?.values?.idEstado[0] || ""}
            isLoading={estados.isLoading}
            options={estados.options}
            onChange={(value) => {
              props.setFieldValue("idMunicipio", []);
              props.setFieldValue("idBairro", []);
              props.setFieldValue("idsServicosAcolhimento", []);
              props.setFieldValue("idEstado", value);
            }}
            visible
            onFocus={estados?.options?.length === 0 ? handleGetEstados : null}
          />
        </GridItem>

        <GridItem colSpan={{ base: 9, lg: 4, xl: 3 }}>
          <CustomMultiSelectWField
            fieldName="idMunicipio"
            label="Município"
            placeholder="Selecione o Município"
            values={props?.values?.idMunicipio[0] || ""}
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={municipios.isLoading}
            options={municipios.options}
            onChange={(value) => {
              props.setFieldValue("idMunicipio", value);
              props.setFieldValue("idBairro", "");

              props.setFieldValue("idsServicosAcolhimento", "");
            }}
            visible
            todos
          />
        </GridItem>

        <GridItem colSpan={{ base: 9, lg: 5, xl: 3 }}>
          <CustomMultiSelectWField
            fieldName="idBairro"
            label={`Bairro`}
            placeholder="Selecione o Bairro"
            values={props?.values?.idBairro[0] || ""}
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={bairros.isLoading}
            options={bairros.options}
            onChange={(value) => {
              props.setFieldValue("idBairro", value);
              props.setFieldValue("idsServicosAcolhimento", "");
            }}
            visible
            todos
          />
        </GridItem>
        <GridItem
          mt={{ base: 10, lg: 0, xl: 10 }}
          colSpan={{ base: 9, lg: 6, xl: 6 }}
        >
          <CustomMultiSelectWField
            fieldName="idsServicosAcolhimento"
            getOptionLabel={(option) => option?.nomeFantasia}
            getOptionValue={(option) => option.id}
            isLoading={
              nomesServicosAcolhimento
                ? nomesServicosAcolhimento.isLoading
                : false
            }
            options={
              nomesServicosAcolhimento ? nomesServicosAcolhimento.options : null
            }
            label="Nome do Serviço de Acolhimento"
            placeholder="Selecione o Nome do Serviço de Acolhimento"
            values={props?.values?.idsServicosAcolhimento[0] || ""}
            visible
            onChange={(value) => {
              props.setFieldValue("idsServicosAcolhimento", value);
            }}
            onFocus={() => handleGetServicosAcolhimento(props)}
          />
        </GridItem>
      </Grid>
    </>
  );
};
